import React, { useEffect, useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Container,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
// import background from "../../assets/background.png";
import AuthBanner from "../../assets/auth_banner.png";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { signIn } from "../../services/auth.service";
import { authSingIn } from "../../Shared/validation";
import {
  addPointNotification,
  buyPointNotification,
} from "../../utils/action/Action";
import "react-toastify/dist/ReactToastify.css";
import "./authentication.scss";
import { getUserDetails } from "../../utils/action/Action";
import { useDispatch } from "react-redux";
import eyeshow from "../../assets/eyeshow.svg";
import eyehide from "../../assets/eyehide.svg";
import Cookies from "js-cookie";
import { getUserPoints } from "../../services/points.service";
import Footer from "../../layout/Footer";
import { GoHome } from "react-icons/go";
import { MdOutlineNavigateNext } from "react-icons/md";

const SignIn = ({ userAuthentication }) => {
  const [passwordType, setPasswordType] = useState("password");
  const [rememberMeChecked, setRememberMeChecked] = useState(false);
  const [showRememberMeModal, setShowRememberMeModal] = useState(false);
  const [LoginClick, setLoginClick] = useState(false);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleRememberMe = () => setShowRememberMeModal(!showRememberMeModal);

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    const checked = Cookies?.get("isChecked");
    setRememberMeChecked(checked);
    const userEmail = Cookies?.get("email");
    const userPassword = Cookies?.get("password");
    setValues({
      email: userEmail,
      password: userPassword,
    });
  }, []);

  const allowCookie = () => {
    if (values?.email || values?.password) {
      Cookies?.set("isChecked", true, { expires: 30 });
      Cookies?.set("email", values?.email, { expires: 30 });
      Cookies?.set("password", values?.password, { expires: 30 });
    }
    setRememberMeChecked(true);
    setShowRememberMeModal(false);
  };

  const notAllowCookie = () => {
    Cookies?.remove("isChecked");
    Cookies?.remove("email");
    Cookies?.remove("password");
    setRememberMeChecked(false);
    setShowRememberMeModal(false);
  };

  const onChecked = (e) => {
    e?.target?.checked === false
      ? notAllowCookie()
      : setShowRememberMeModal(true);
  };

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const handleChange = (e) => {
    const newData = { ...values };
    newData[e?.target?.id] = e?.target?.value?.trim()?.replace(regex, "");
    errors[e?.target?.id] = null;

    const userEmail = Cookies?.get("email");
    const userPassword = Cookies?.get("password");
    if (userEmail === newData || userPassword === newData) {
      setRememberMeChecked(true);
    } else {
      setRememberMeChecked(false);
    }
    setValues(newData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // validation for password and email
    if (values?.email === "" || values?.password === "") {
      toast.error("Please enter email and password");
      return;
    } else if (values?.email === "") {
      toast.error("Please enter email");
      return;
    } else if (values?.password === "") {
      toast.error("Please enter password");
      return;
    }

    // validate email
    if (!values?.email?.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      toast.error("Please enter valid email");
      return;
    }

    if (rememberMeChecked === false) {
      notAllowCookie();
    }
    const errors = await authSingIn(values);
    setErrors(errors);
    if (errors === null) {
      setErrors({});
      setLoginClick(true);
      try {
        const response = await signIn({
          username: values?.email,
          password: values?.password,
        });
        if (response?.status === 200 && response?.data?.error === false) {
          setValues(response?.data);
          localStorage?.setItem("token", response?.data?.data?.access_token);
          localStorage?.setItem(
            "refresh_token",
            response?.data?.data?.refresh_token
          );
          try {
            const response = await getUserPoints({
              userName: values?.email,
            });
            if (response && response?.status === 200) {
              if (
                response?.data?.data?.userPoints <= 20 &&
                response?.data?.data?.userPoints >= 1
              ) {
                let obj = {
                  notification: true,
                };
                dispatch(addPointNotification(obj));
              } else if (response?.data?.data?.userPoints === 0) {
                let obj = {
                  notification: true,
                };
                dispatch(buyPointNotification(obj));
              }
            }
          } catch {}

          userAuthentication();
          await dispatch(getUserDetails());

          let lastPath = localStorage?.getItem("pathName");
          let pathName = "";
          if (lastPath) {
            pathName = lastPath;
            localStorage?.removeItem("pathName");
          } else {
            pathName = "/";
          }

          return (
            toast.success("Sign In Successfully!", {
              position: toast.POSITION.TOP_RIGHT,
            }),
            navigate(pathName, {
              state: { categoryName: localStorage?.getItem("Category") },
            }),
            setTimeout(() => {
              // window.location.reload();
              navigate("/");
            }, 2000)
          );
        } else {
          toast.error("Invalid Credentials", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setLoginClick(false);
        }
      } catch (err) {
        let error_message = "Invalid Credentials";
        if (
          err?.response &&
          err?.response?.data &&
          err?.response?.data?.message
        ) {
          error_message = err?.response?.data?.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        setLoginClick(false);
      }
    }
  };

  const isDiasabled = () => {
    if (LoginClick === true) {
      return true;
    }
  };

  return (
    <section>
      <Container>
        <Breadcrumb className="nt-breadcrumb">
          <Link to="/" className="breadcrumb_item1">
            <GoHome className="home_icon" />
          </Link>
          <span className="breadcrumb-divider">
            <MdOutlineNavigateNext />
          </span>
          <BreadcrumbItem active>
            <Link to="/sign-in" className="nt-breadcrumb_item2">
              Log In
            </Link>
          </BreadcrumbItem>
        </Breadcrumb>
        <div className="signin_section">
          <Modal
            className="addnew_route cookies"
            isOpen={showRememberMeModal}
            toggle={toggleRememberMe}
          >
            <ModalHeader toggle={toggleRememberMe} />
            <ModalBody>
              <p>We use cookies to improve your experience</p>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => allowCookie()}>Allow Cookies</Button>
              <Button onClick={() => notAllowCookie()}>Not Now</Button>
            </ModalFooter>
          </Modal>
          <div className="signin_container">
            <div className="Leftsection">
              <img src={AuthBanner} alt="" />
            </div>
            <div className="Rightsection">
              <Form className="signinform" onSubmit={handleSubmit}>
                <h3>Sign In To Your Account</h3>
                <p>
                  Enter your Email ID and Password to sign in to your account.
                </p>
                <div className="form_section">
                  <FormGroup>
                    <Label>Email*</Label>
                    <Input
                      id="email"
                      name="email"
                      autoComplete="off"
                      value={values?.email}
                      onChange={handleChange}
                      placeholder="Email ID"
                      autoCapitalize="none"
                      type="email"
                    />
                    <span className="error">
                      {errors?.email && errors?.email}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <div className="password">
                      <Label>Password*</Label>
                      <Input
                        id="password"
                        name="password"
                        autoComplete="off"
                        value={values?.password}
                        onChange={handleChange}
                        placeholder="Password"
                        type={passwordType}
                      />
                      <Link to="#" onClick={togglePassword}>
                        {passwordType === "password" ? (
                          // <BiHide
                          //   className="hideicon"
                          //   size={25}
                          //   style={{ color: "#2B2D33" }}
                          // />
                          <img
                            src={eyeshow}
                            style={{ marginTop: "31px" }}
                            alt="show"
                          />
                        ) : (
                          // <BiShow
                          //   className="showicon"
                          //   size={25}
                          //   style={{ color: "#2B2D33" }}
                          // />
                          <img
                            src={eyehide}
                            style={{ marginTop: "31px" }}
                            alt="hide"
                          />
                        )}
                      </Link>
                    </div>
                    <span className="error">
                      {errors?.password && errors?.password}
                    </span>
                  </FormGroup>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      checked={rememberMeChecked}
                      onChange={(e) => onChecked(e)}
                    />
                    <Label className="check_box" check>
                      Remember me
                    </Label>
                    <Link className="forgotpassword" to="/forgot-password">
                      <span>Forgot password?</span>
                    </Link>
                  </FormGroup>
                  <Button type="submit" disabled={isDiasabled()}>
                    {LoginClick === true ? (
                      <Spinner size="sm"></Spinner>
                    ) : (
                      "Sign In"
                    )}
                  </Button>

                  <div className="no_account">
                    <Label className="noaccount">Don’t have an account?</Label>
                    <Link to="/sign-up" className="signup">
                      Sign Up
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </section>
  );
};

export default SignIn;
